import { STOREFRONT_API_VERSION } from './constants';
import { createClient } from '@digismoothie/shared-candyrack';

const createCandyRackClient = (storefrontAccessToken: string) => {
  return createClient(storefrontAccessToken, STOREFRONT_API_VERSION);
};

export default createCandyRackClient;
